import home from './home'
import webusers from './webusers'
import settings from './settings'
import finance from './finance'
import crm from './crm'

//Array of sections
export default [
    ...home,
    // ...crm,
    ...webusers,
    ...finance,
    ...settings
]
